import { Box, InputAdornment, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import { ErrorMessage } from 'formik'
import React from 'react'

const ProRata = ({
  adjustDays,
  setAdjustDays,
  // setWorkdaysState,
  selectValue,
  formikProps,
  setStateChanges,
}) => {
  const { values, setFieldValue, handleBlur, errors, touched } = formikProps
  const handleReset = () => {
    setAdjustDays(false)
    setFieldValue('quantity', selectValue?.salary?.quantity)
    setStateChanges(true)
    // setWorkdaysState(selectValue?.salary?.quantity);
  }
  const handleAdjust = () => {
    setAdjustDays(true)
  }
  const handleQuantityChange = (e) => {
    const { value } = e.target
    setFieldValue('quantity', value)
    setStateChanges(true)
  }

  return (
    <Box display="flex" alignItems="flex-start" columnGap={2} width="100%">
      <Box>
        <AdxInput
          label={<Typography variant="subtitle2">Salary type</Typography>}
          disabled
          sxLabel={{
            color: 'light-gray-text.main',
          }}
          sxInput={{
            color: 'light-gray-text.main',
            backgroundColor: 'white.main',
          }}
          value={selectValue?.salary?.type}
        />
      </Box>
      <Box>
        {selectValue?.salary?.salary_category !== 'Hourly' ? (
          <AdxInput
            name="quantity"
            label={<Typography variant="subtitle2">Total working days</Typography>}
            type="number"
            inputProps={{ min: 0, step: 0.5 }}
            endAdornment={<InputAdornment position="end">Days</InputAdornment>}
            disabled={adjustDays === false}
            sxLabel={{
              color:
                adjustDays === false
                  ? 'light-gray-text.main'
                  : 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxInput={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            value={adjustDays ? values.quantity ?? '' : selectValue?.salary?.quantity}
            onChange={handleQuantityChange}
            onBlur={handleBlur}
            isErrorShown={errors.quantity && touched.quantity}
            errorMessage={<ErrorMessage name="quantity" component={AdxErrorMessage} />}
          />
        ) : (
          <AdxInput
            name="quantity"
            label={<Typography variant="subtitle2">Total working hours</Typography>}
            type="number"
            inputProps={{ min: 0, step: 0.5 }}
            endAdornment={<InputAdornment position="end">hours</InputAdornment>}
            disabled={adjustDays === false}
            sxLabel={{
              color:
                adjustDays === false
                  ? 'light-gray-text.main'
                  : 'dark-text.main' /*, fontSize: "30px!important" */,
            }}
            sxInput={{
              color: 'light-gray-text.main',
              backgroundColor: 'white.main',
            }}
            value={adjustDays ? values.quantity ?? '' : selectValue?.salary?.quantity}
            onChange={handleQuantityChange}
            onBlur={handleBlur}
            isErrorShown={errors.quantity && touched.quantity}
            errorMessage={<ErrorMessage name="quantity" component={AdxErrorMessage} />}
          />
        )}
      </Box>
      <Box>
        <AdxInput
          label={<Typography variant="subtitle2">Amount</Typography>}
          disabled
          sxLabel={{
            color: 'light-gray-text.main',
          }}
          sxInput={{
            color: 'light-gray-text.main',
            backgroundColor: 'white.main',
          }}
          startAdornment={<InputAdornment position="start">RM</InputAdornment>}
          value={selectValue?.salary?.basic?.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          sx={{ width: '100%' }}
        />
      </Box>
      <Box display="flex" alignItems="flex-end" height="70px">
        {selectValue &&
          (adjustDays ? (
            <AdxButton variant={'ghost'} sx={{ textDecoration: 'underline' }} onClick={handleReset}>
              Reset
            </AdxButton>
          ) : (
            <AdxButton
              variant={'ghost'}
              sx={{ textDecoration: 'underline' }}
              onClick={handleAdjust}
            >
              Adjust
            </AdxButton>
          ))}
      </Box>
    </Box>
  )
}

export default ProRata
